// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import SouthSudan from '../_raw/flag/icon_flag_south_sudan.png';

export default () => <img src={SouthSudan} alt="SouthSudan" />;
